export const LOADING_LEAVEBALANCE = "LOADING_LEAVEBALANCE";
export const GET_LEAVEBALANCE_EMPLOYEE = "GET_LEAVEBALANCE_EMPLOYEE";
export const GET_LEAVEBALANCE_SUBORDINATES = "GET_LEAVEBALANCE_SUBORDINATES";